import React, {
  createContext,
  useMemo,
  useState,
  PropsWithChildren,
} from 'react';
import { ClaimDetails, PreviousClaimedCondition } from '@agria/paws/src/types';

export interface ConfirmedData {
  treatmentDate?: string;
  claimedAmount?: string | number;
  isContinuationClaim?: 'yes' | 'no';
  previousClaim?: PreviousClaimedCondition;
  hasPassedAway?: 'yes' | 'no';
  deathDate?: string;
  burialCharge?: string | number;
  illnessInjury?: string;
}

export interface ClaimContextProps {
  claimDetails?: ClaimDetails;
  setClaimDetails: React.Dispatch<
    React.SetStateAction<ClaimDetails | undefined>
  >;
  confirmedData: ConfirmedData;
  setConfirmedData: React.Dispatch<React.SetStateAction<ConfirmedData>>;
}

const initialState: ClaimContextProps = {
  claimDetails: undefined,
  setClaimDetails: () => {},
  confirmedData: {},
  setConfirmedData: () => {},
};

export const ClaimContext = createContext<ClaimContextProps>(initialState);

ClaimContext.displayName = 'ClaimContext';

export const ClaimProvider = ({ children }: PropsWithChildren) => {
  const [claimDetails, setClaimDetails] = useState<ClaimDetails>();
  const [confirmedData, setConfirmedData] = useState<ConfirmedData>({});

  const contextValues = useMemo(
    () => ({
      claimDetails,
      setClaimDetails,
      confirmedData,
      setConfirmedData,
    }),
    [claimDetails, confirmedData]
  );

  return (
    <ClaimContext.Provider value={contextValues}>
      {children}
    </ClaimContext.Provider>
  );
};
